import { render, staticRenderFns } from "./cefloreco-lets-talk.vue?vue&type=template&id=f3271f90&scoped=true&"
import script from "./cefloreco-lets-talk.vue?vue&type=script&lang=js&"
export * from "./cefloreco-lets-talk.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-lets-talk.vue?vue&type=style&index=0&id=f3271f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3271f90",
  null
  
)

export default component.exports